import { User } from "firebase/auth"
import { createContext } from "react"

export const persistedUser = localStorage.getItem("user")
	? (JSON.parse(localStorage.getItem("user") as string) as User)
	: undefined

export const UserContext = createContext<User | undefined>(persistedUser)
